import React from "react";
import { GlobalOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import {
  APP_LANGUAGES,
  EU_OFFICIAL_LANGUAGES,
  EXTRA_LANGUAGES,
  LANGUAGE_NATIVE_LABELS,
  resolveAppLanguage,
  type AppLanguage,
} from "../i18n";
import { persistLocaleToProfile } from "../auth/profileLocale";

function optionLabel(code: AppLanguage): string {
  return `${LANGUAGE_NATIVE_LABELS[code]} (${code.toUpperCase()})`;
}

const OPTIONS = [
  {
    label: "EU",
    options: EU_OFFICIAL_LANGUAGES.map((code) => ({
      value: code,
      label: optionLabel(code),
    })),
  },
  {
    label: "Other",
    options: EXTRA_LANGUAGES.map((code) => ({
      value: code,
      label: optionLabel(code),
    })),
  },
];

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = resolveAppLanguage(i18n.language);

  return (
    <span data-testid="language-switcher" data-languages={APP_LANGUAGES.join(",")}>
      <Select
        showSearch
        size="small"
        value={current}
        aria-label={t("app.language.switcher")}
        optionFilterProp="label"
        popupMatchSelectWidth={false}
        style={{ minWidth: 168 }}
        suffixIcon={<GlobalOutlined />}
        options={OPTIONS}
        onChange={(lng: AppLanguage) => {
          void (async () => {
            await i18n.changeLanguage(lng);
            await persistLocaleToProfile(lng);
          })();
        }}
        listHeight={320}
      />
    </span>
  );
}

export { APP_LANGUAGES, EU_OFFICIAL_LANGUAGES };
